import CustomPageNotification from "@components/layouts/CustomPageNotification";
import {
  Alert,
  Button,
  Center,
  Divider,
  Group,
  Loader,
  Modal,
  Stack,
  Text,
} from "@mantine/core";
import { printPage } from "common/utils";
import { useAgedTrialBalance } from "hooks/useAgedTrialBalanceFetch";
import React, { useState } from "react";
import { AgedTrialBalance } from "types/model.types";
import AgedTrialBalanceTransactionView from "./components/AgedTrialBalanceTransactionView";

const AdminAgedTrialBalancePage: React.FC = () => {
  const [preview, setPreview] = useState<boolean>(true);
  const { data, loading, error, refresh } = useAgedTrialBalance();
  const [exporting, setExporting] = useState(false);

  const handlePrint = async () => {
    const elementsToHide = document.querySelectorAll(".no-print");
    elementsToHide?.forEach((el) => {
      (el as HTMLElement).style.display = "none";
    });

    const preview = document.getElementById("preview-content");
    if (!preview) {
      return;
    }
    printPage(preview.innerHTML);

    elementsToHide?.forEach((el) => {
      (el as HTMLElement).style.display = "";
    });
  };

  if (loading)
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );

  if (error)
    return (
      <Alert title="Error" color="red">
        {error}
      </Alert>
    );
  return (
    <>
      <CustomPageNotification
        title="Aged Trial Balance Report"
        message="Click re-run report to view the latest data. You can print the report from the preview modal."
      />
      <Button style={{ margin: "10px 0px" }} onClick={() => setPreview(true)}>
        Re-run Report
      </Button>
      <Modal
        opened={preview}
        onClose={() => setPreview(false)}
        fullScreen
        title="Debtor's Aged Trial Balance Preview"
        size="xl"
        centered
        closeOnEscape={false}
        withinPortal={true}
        zIndex={2001}
      >
        {!exporting && (
          <Group justify="flex-end" mb="md" className="no-print">
            <Button onClick={handlePrint} variant="default">
              Print
            </Button>
          </Group>
        )}
        <Center
          w={"100%"}
          mb="md"
          style={{ marginBottom: "1rem", borderBottom: "2px solid #ccc" }}
        >
          <Text size="xl" style={{ fontSize: "2.5rem" }} fw={700}>
            John Jacobson Limited
          </Text>
        </Center>
        <Center w={"100%"} mb="md" style={{ marginBottom: "1rem" }}>
          <Text size="lg" style={{ fontSize: "1.5rem" }} fw={700}>
            Debtors Aged Trial Balance
          </Text>
        </Center>
        <Divider my={"md"} />
        <Stack
          id="preview-content"
          style={{
            width: "100%",
            minWidth: "794px", // A4 width in pixels
            margin: "0 auto", // center on screen
          }}
        >
          {data.map((debtor: AgedTrialBalance, idx) => (
            <>
              <AgedTrialBalanceTransactionView
                key={`${idx}-${debtor.id}`}
                debtor={debtor}
              />
              <Divider my={"md"} />
            </>
          ))}
        </Stack>
      </Modal>
    </>
  );
};

export default AdminAgedTrialBalancePage;
